<template>
  <div id="content" class="bg-white">

    <!-- Modal passage_subject -->
    <div class="modal fade" id="passage_subject" tabindex="-1" aria-labelledby="passage_subject_label" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="passage_subject_label">{{ current_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-html="current_subject">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>


    <div id="alert_message" class="alert alert-success alert-dismissible alert-modal d-none" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      {{message}}
    </div>

    <div class="modal fade text-body" id="passage_modal" tabindex="-1" role="dialog"
         aria-labelledby="passage_modalLabel">
      <form id="passage_form"
            @submit.prevent="post_passage">

        <input type="hidden" name="method"     :value="method">
        <input v-if="passage_id != 0" type="hidden" name="passage_id" :value="passage_id">

        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="new_document_modalLabel">Ajouter un passage</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                  aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">

              <div class="form-group">
                <label for="title">Titre</label>
                <input type="text" class="form-control" id="title" name="title" v-model="passage.title"
                       aria-describedby="Titre du passage">
                <small class="form-text text-muted">Veuillez saisir un titre en 3 et 128 caractères.</small>
              </div>

              <div class="form-group trix-without-download trix-without-history">
                <label for="subject">Sujet</label>
                <ckeditor :editor="editor" v-model="subject" :config="editor_config" name="subject">
                </ckeditor>
              </div>

              <div class="row">

                <div class="required form-group col-md-6"
                     v-for="attribute in attributes"
                     :key="attribute.id">
                  <label :for="attribute.id" class="required">
                    {{ attribute.name }}
                  </label>

                  <select :id="attribute.id" :name="attribute.id"
                          class="form-control"
                          v-if="attribute.kind == 0">
                    <option v-for="value in attribute.values"
                            :key="value.id"
                            :value="value.id">{{value.value}}
                    </option>
                  </select>
                </div>

              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
              </button>
              <button
                  :disabled="submit_disabled == true"
                  type="submit"
                  class="btn btn-primary"
                  name="new_document" >
                <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div id="dlnkpassages-passages-page" class="p-0">

      <div class="position-relative bg-light">
        <div class="container space-1 space-top-lg-1 space-bottom-sm-2 space-bottom-lg-2">
          <!-- Title -->
          <div class="w-md-80 w-lg-65 text-center mx-md-auto mb-5 mb-md-4">
            <h1 class="mb-0 text-secondary">Passages</h1>
          </div>
          <!-- End Title -->

          <div class="text-center mb-lg-4">

            <button type="button" class="btn btn-primary" @click="new_passage()">
              <span>
                <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;
                Saisir un passage
              </span>
            </button>
          </div>
        </div>

        <!-- SVG Bottom Shape -->
        <figure class="position-absolute bottom-0 right-0 left-0">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               viewBox="0 0 1920 100.1">
            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
          </svg>
        </figure>
        <!-- End SVG Bottom Shape -->
      </div>

      <div class="container">
        <div class="row justify-content-lg-between">

          <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" id="archived" name="archived" v-model="show_archived">
            <label class="form-check-label" for="archived">
              Basculer vers les éléments archivés
            </label>
          </div>


          <table class="table">
            <thead>
            <tr>
              <th scope="col">Quand</th>
              <th scope="col">Status</th>
              <th scope="col">Titre</th>
              <th scope="col"
                  v-for="attribute in attributes"
                  :key="attribute.id">
                {{ attribute.name }}
              </th>
              <th scope="col" width="190px">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="passage in passages" :key="passage.passage_id"
                v-bind:class="{ 'bg-success text-white': passage.status == 55 }">
              <th scope="row">{{passage.created_at}}</th>
              <th scope="row">{{passage.status}}</th>
              <td>
                <!-- Button trigger modal -->
                <a href="javascript:" data-toggle="modal" data-target="#passage_subject"
                        @click="fill_subject_modal(passage.title, passage.subject)">
                  {{ passage.title }}
                </a>
              </td>
              <td v-for="attribute in attributes"
                  :key="attribute.id">
                {{ passage.values[attribute.id] }}
              </td>
              <td>

                <button type="button" class="btn btn-info" title="Modifier le sujet" data-tooltip="tooltip"
                        @click="edit_passage(passage)">
                  <i class="fas fa-edit"></i>
                </button>


                <form v-if="passage.archived == 1"  class="d-inline" :id="'restore_passage_'+passage.passage_id"
                      @submit.prevent="patch_passage('restore_passage_' + passage.passage_id)">
                  <input type="hidden" name="archived" value="0">
                  <input type="hidden" name="id"      :value="passage.passage_id">

                  <button type="submit" class="btn btn-info" title="Restaurer le sujet" data-tooltip="tooltip">
                    <i class="fas fa-rocket"></i>
                  </button>
                </form>
                <div v-else class="d-inline">

                  <form v-if="passage.status != 55" class="d-inline" :id="'done_passage_'+passage.passage_id"
                        @submit.prevent="patch_passage('done_passage_' + passage.passage_id)">
                    <input type="hidden" name="status" value="55">
                    <input type="hidden" name="id"    :value="passage.passage_id">
                    <button type="submit" class="btn btn-success" title="Sujet traité" data-tooltip="tooltip">
                      <i class="fas fa-check"></i>
                    </button>
                  </form>

                  <form v-if="passage.status == 55" class="d-inline" :id="'reopen_passage_'+passage.passage_id"
                        @submit.prevent="patch_passage('reopen_passage_' + passage.passage_id)">
                    <input type="hidden" name="status" value="2">
                    <input type="hidden" name="id"    :value="passage.passage_id">
                    <button type="submit" class="btn btn-info" title="Réouvrir le sujet" data-tooltip="tooltip">
                      <i class="fas fa-rocket"></i>
                    </button>
                  </form>

                  <form class="d-inline" :id="'archive_passage_'+passage.passage_id"
                        @submit.prevent="patch_passage('archive_passage_' + passage.passage_id)">
                    <input type="hidden" name="archived" value="1">
                    <input type="hidden" name="id"       :value="passage.passage_id">
                    <button type="submit" class="btn btn-info" title="Archiver le sujet" data-tooltip="tooltip">
                      <i class="fas fa-archive"></i>
                    </button>
                  </form>

                </div>


                <form :id="'delete_passage_'+passage.passage_id" class="d-inline"
                    @submit.prevent="delete_passage(passage.passage_id)">
                  <input type="hidden" name="method" value="delete">
                  <button type="submit" class="btn btn-danger" title="supprimer ce passage" data-tooltip="tooltip">
                   <i class="fas fa-trash"></i>
                  </button>
                </form>
              </td>
            </tr>
            </tbody>
          </table>

        </div>

      </div>

    </div>
  </div>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: ['group_id'],
  data: function () {
    return {
      passages: [],
      attributes: [],
      message: '',
      query: '',
      order_by: 'date',
      order_direction: 'asc',
      company: Object,
      method: 'post',
      passage_id: 0,
      subject: "",

      passage: Object,

      current_title: "",
      current_subject: "",

      show_archived: false,

      errors: {
        subject: false,
      },
      editor: ClassicEditor,
      editor_config: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      }
    }
  },
  mounted() {
    this.get_passages();
  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  watch: {
    show_archived: function (new_val, old_val) {
      this.get_passages()
    },
  },

  methods: {

    fill_subject_modal: function (title, subject) {
      this.current_title = title
      this.current_subject = subject
    },

    get_passages: function () {
      const _this = this

      let url = '/modules/dlnkpassages/actions/passages.php'

      if (_this.show_archived) {
        url = url + '?archived=1'
      }

      axios.get( url)
          .then(function (response) {
            const attributes = response.data.attributes
            const passages = response.data.passages

            for (const attribute of attributes) {
              attribute['values'] = JSON.parse(attribute.values)
            }
            _this.attributes = attributes;

            for (const passage of passages) {
              let vals = [];
              const values = JSON.parse(passage.values)
              for (const value of values) {
                vals[value.attribute_id] = value.value;
              }
              passage['values'] = vals;
            }
            _this.passages = passages;

            _this.company = response.data.company
            _this.is_admin = response.data.is_admin
          })
          .catch(function (error) {
            // console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    validate_subject: function () {
      this.errors.subject = false;
      if(this.subject.length < 3 ) {
        this.errors.subject = true;
      }
    },

    reset_passage: function () {
      this.passage.title = ''

    },

    edit_passage: function (passage) {
      const _this = this
      _this.passage = passage
      _this.method = 'patch'
      $('#passage_modal').modal('show')
    },

    new_passage: function () {
      this.reset_passage()
      $('#passage_modal').modal('show')
    },

    post_passage: function () {
      const _this = this;
      const url = '/modules/dlnkpassages/actions/passages.php'

      const form_element = document.getElementById("passage_form");
      const form_data = new FormData(form_element);
      form_data.append('subject', _this.subject);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              $('#passage_modal').modal('hide');
              _this.get_passages();
              if (_this.method === 'post') {
                _this.message = "Passage ajouté.";
              } else if (_this.method === 'patch') {
                _this.message = "Passage modifié.";
              }
              const element = document.getElementById("alert_message");
              element.classList.remove("d-none");
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    patch_passage: function (form_id) {

      if (confirm('Confirmer ?')) {
        const _this = this;
        const url = '/modules/dlnkpassages/actions/passages.php';

        const form_element = document.getElementById(form_id);
        const form_data = new FormData(form_element);
        form_data.append('method', 'patch')

        axios({
          method: 'post',
          url: url,
          data: form_data,
          headers: {'Content-Type': 'multipart/form-data' }
        })
            .then(function (response) {
              const status = response.data.status;

              if(status) {
                _this.get_passages();
              } else {
                _this.errors = response.data.errors;
              }
            })
            .catch(function (response) {
              //handle error
            });
      }

    },

    delete_passage: function (id) {

      if (confirm('Êtes-vous sûr de supprimer ce passage ?')) {
        const _this = this;
        const url = '/modules/dlnkpassages/actions/passages.php';

        const form_element = document.getElementById("delete_passage_"+id);
        const form_data = new FormData(form_element);
        form_data.append('id_passage', id);

        axios({
          method: 'post',
          url: url,
          data: form_data,
          headers: {'Content-Type': 'multipart/form-data' }
        })
            .then(function (response) {
              //handle success
              const status = response.data.status;

              if(status) {
                _this.get_passages();
                _this.message = "Passage supprimé.";
                const element = document.getElementById("alert_message");
                element.classList.remove("d-none");
              } else {
                _this.errors = response.data.errors;
              }
            })
            .catch(function (response) {
              //handle error
            });
      }

    },
  },
}
</script>
